import gameConfig from '../config/gameConfig'

const {
  defaultScore,
  entryFee,
  winBonus,
  storageKey,
  profileStorageKey,
  dailyBonusWhenZero,
  minScoreToMatch,
} = gameConfig.rating

function todayKey() {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export function loadRating() {
  try {
    const raw = localStorage.getItem(storageKey)
    const n = raw != null ? parseInt(raw, 10) : NaN
    if (Number.isFinite(n)) return n
  } catch {
    /* ignore */
  }
  return defaultScore
}

export function saveRating(score) {
  try {
    localStorage.setItem(storageKey, String(score))
  } catch {
    /* ignore */
  }
}

/**
 * 进入大厅时调用：积分为 0 且当日未领取时发放 dailyBonusWhenZero。
 * @returns {{ granted: boolean, amount: number, score: number }}
 */
export function applyDailyLoginBonusIfEligible() {
  const score = loadRating()
  if (score > 0) {
    return { granted: false, amount: 0, score }
  }
  const profile = loadProfile()
  const today = todayKey()
  if (profile.lastDailyBonusDate === today) {
    return { granted: false, amount: 0, score: 0 }
  }
  const amount = dailyBonusWhenZero ?? 3
  const after = score + amount
  saveRating(after)
  saveProfile({ ...profile, lastDailyBonusDate: today })
  return { granted: true, amount, score: after }
}

/** 是否允许开始匹配（积分不足时不可匹配） */
export function canStartMatch() {
  return loadRating() >= (minScoreToMatch ?? entryFee)
}

/** 点击开始匹配：立即扣除入场分 */
export function chargeMatchEntry() {
  const before = loadRating()
  if (before < entryFee) {
    return { ok: false, before, after: before, fee: entryFee }
  }
  const after = before - entryFee
  saveRating(after)
  return { ok: true, before, after, fee: entryFee }
}

/** 胜局奖励（入场费已在匹配时扣除） */
export function applyMatchWinBonus() {
  const before = loadRating()
  const after = before + winBonus
  saveRating(after)
  return after
}

export function loadProfile() {
  try {
    const raw = localStorage.getItem(profileStorageKey)
    if (raw) return JSON.parse(raw)
  } catch {
    /* ignore */
  }
  return {}
}

export function saveProfile(profile) {
  try {
    localStorage.setItem(profileStorageKey, JSON.stringify(profile))
  } catch {
    /* ignore */
  }
}

export function getRatingRulesForUi() {
  return {
    entryFee,
    winBonus,
    defaultScore,
    dailyBonusWhenZero: dailyBonusWhenZero ?? 3,
    minScoreToMatch: minScoreToMatch ?? entryFee,
  }
}